module.exports = __webpack_public_path__ + "media/images/haircut/cover-desktop-c14bb6e2cda9acd80fe42363373d8f29.jpg";